import { QueryLayoutProps } from 'modules/queryBuilder/contexts';
import styled from 'styled-components';
import { QueryLayout } from 'ui/queryBuilder';
import { useCatalogPreviewContext } from './contexts/CatalogPreviewContext';

const QueryLayoutWrapper = styled.div`
  &[data-previewopen='false'] {
    margin-bottom: 35vh;
  }
  &[data-previewopen='true'] {
    margin-bottom: 15vh;
  }
`;

export const DATA_TEST = {
  wrapper: 'customized-qb-layout-wrapper',
};

export const CustomizedQueryLayout = (props: QueryLayoutProps) => {
  const { isOpen } = useCatalogPreviewContext();
  return (
    <QueryLayoutWrapper data-test={DATA_TEST.wrapper} data-previewopen={isOpen}>
      <QueryLayout {...props} />
    </QueryLayoutWrapper>
  );
};
